import React, {Component, ReactFragment, ReactNode} from 'react';
import classNames from "classnames";
import style from './style.module.scss';
import {Fab, Theme, Tooltip, withStyles} from '@material-ui/core';
import MuiIconButton from '@material-ui/core/IconButton';
import {IProps} from './types';
import IconsService from "external-services/icons-service/icons.service";
import AppThemeService from 'app/services/theme/appTheme.service';

const NS = 'IconButton';

export default function Index({
  iconType, useUnderlinedVersion, isSelected, useReversedColors, clearMargins, tooltip, e2eBtnValue,
  clickHandler, height, width
}: IProps) {

  const theme: Theme = AppThemeService.getAppTheme();

  const IconButton = withStyles({
    root: {
      padding: 6,
      height: height,
      width: width,
      color: useReversedColors
        ? (!isSelected
          ? 'rgba(255,255,255,0.87)'
          : 'rgba(255,255,255,0.4)'
        ) : (!isSelected
          ? 'rgba(0, 0, 0, 0.87)'
          : 'rgba(0, 0, 0, 0.4)'
        )
    }
  })(MuiIconButton);

  const Icon = IconsService.getIcon(iconType);
  const Btn: React.FC<any> = () => useUnderlinedVersion
    ? (
      <div className={classNames({
        [style.btnIsUl]: true,
        [style.btnIsUlIsSelected]: !isSelected
      })} style={{
        borderBottomColor: theme.palette.primary.main
      }}>
        <IconButton aria-label={iconType} onClick={clickHandler} data-e2e={e2eBtnValue || 'icon-button' + iconType}>
          <Icon />
        </IconButton>
      </div>
    ) : (
      <Fab color={isSelected ? 'default' : 'primary'} style={{height: height, width: width}} onClick={clickHandler} data-e2e={e2eBtnValue || 'icon-button' + iconType}>
        <Icon />
      </Fab>
    );

  return (
    <div className={classNames({
      [style.root]: true,
      [style.rootClearMargins]: clearMargins
    })}>
      {Icon ? (
        tooltip
          ? (<Tooltip title={tooltip} aria-label={tooltip} arrow>
              <div>
                {/* needs to be wrapped in another element because functional component doesn't work in tooltip */}
                <Btn />
              </div>
            </Tooltip>)
          : <Btn />
      ) : <span>[IconButton]</span>}
    </div>
  );
}
